/**
 * "Teams or memberships just changed", for everything that reads them from the
 * Postgres mirror. Two channels, by what the reader needs to hear:
 *
 *  - `TEAMS_ADDED`, for the tables (the company's Teams, a Team's members and a
 *    member's Teams): something new a table can list. A new Team (New Team,
 *    wherever it is opened, and a Team plan signup), an invitation sent (the
 *    Invite button), and the Teams someone joins (accepting an invitation, and
 *    Membership Reconciliation). An edit is not one (a rename, a role,
 *    deactivating or reactivating): a row already listed follows it through its
 *    binding and stays where it is, out of sort or out of filter, until Refresh.
 *    A row whose document is gone is marked removed by its binding, and its
 *    table asks again by itself.
 *  - `TEAMS_CHANGED`, for the company and member dashboard cards (the counts):
 *    every change, the additions included.
 *
 * A table listens through CursorListMixin's `listChangeChannel`; a dashboard
 * subscribes itself. A change someone else makes reaches nobody this way: rows
 * already on screen follow it through their bindings, and the listing catches up
 * on the next fetch.
 */
import moment from 'moment-timezone';
import { MirrorLagChannel, createMirrorLagChannel } from '@/utils/mirrorLagChannel';

export const TEAMS_ADDED: MirrorLagChannel = createMirrorLagChannel();

export const TEAMS_CHANGED: MirrorLagChannel = createMirrorLagChannel();

/** Something new a table can list: the tables catch up, and so do the counts. */
export function noteTeamsAdded (now?: moment.Moment): void {
	TEAMS_ADDED.noteChanged(now);
	TEAMS_CHANGED.noteChanged(now);
}

/** Any other change to Teams or memberships: only the counts catch up. */
export function noteTeamsChanged (now?: moment.Moment): void {
	TEAMS_CHANGED.noteChanged(now);
}
